import Layout from './Layout.container';

export default Layout;
